import { Button, CircularProgress, Modal } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { db, storage } from "../../../firebase";
import { departmentMapping, designationMapping } from "../../../mapping";

function MembersForm({ state, setReRender, data }) {
  const [showModal, setShowModal] = state;
  const [selectedFile, setSelectedFile] = useState(null);
  const [preview, setPreview] = useState(data ? data.photo : "");
  const [firstName, setFirstName] = useState(data ? data.firstName : "");
  const [middleName, setMiddleName] = useState(data ? data.middleName : "");
  const [lastName, setLastName] = useState(data ? data.lastName : "");
  const [priority, setPriority] = useState(data ? data.priority : "1");
  const [designation, setDesignation] = useState(
    data ? data.designation : "Default"
  );
  const [department, setDepartment] = useState(
    data ? data.department : "Default"
  );
  const [modalLoading, setModalLoading] = useState(false);

  const closeModalHandler = () => {
    setSelectedFile(null);
    setShowModal(false);
  };

  const submitHandler = async () => {
    setModalLoading(true);

    try {
      if (!data) {
        const key = db.collection("Committee").doc();
        const ref = storage.ref().child(`Committee/${key.id}`);
        let url =
          "https://media.istockphoto.com/vectors/user-avatar-profile-icon-black-vector-illustration-vector-id1209654046?k=6&m=1209654046&s=612x612&w=0&h=sNiHvwJm5SPrpTCjz-7eqSDqew5-f2hASM2FrGLtMJ4=";

        if (selectedFile) {
          await ref.put(selectedFile);
          url = await ref.getDownloadURL();
        }

        await key.set({
          key: key.id,
          firstName,
          middleName,
          lastName,
          designation,
          designationKey: designationMapping[designation],
          departmentKey: departmentMapping[department],
          department,
          photo: url,
          priority: priority ? Number(priority) : 1,
        });
      } else {
        //Updation NOT INSERTION
        // console.log(selectedFile);
        const key = data.key;
        if (selectedFile) {
          const ref = storage.ref(`Committee/${key}`);
          await ref.delete();
          await ref.put(selectedFile);
          const url = await ref.getDownloadURL();

          await db
            .collection("Committee")
            .doc(key)
            .update({
              firstName,
              middleName,
              lastName,
              designation,
              designationKey: designationMapping[designation],
              department,
              departmentKey: departmentMapping[department],
              photo: url,
              priority: Number(priority),
            });
        } else {
          await db
            .collection("Committee")
            .doc(key)
            .update({
              firstName,
              middleName,
              lastName,
              designation,
              designationKey: designationMapping[designation],
              department,
              departmentKey: departmentMapping[department],
              priority: Number(priority),
            });
        }
      }

      // console.log(preview);

      setModalLoading(false);
    } catch (e) {
      console.log(e);
      setModalLoading(false);
    }

    setSelectedFile(null);
    setPreview("");
    setFirstName("");
    setMiddleName("");
    setLastName("");
    setDepartment("Default");
    setDesignation("Default");
    setReRender((p) => !p);
    setShowModal(false);
  };

  // console.log(preview);

  useEffect(() => {
    if (!selectedFile) {
      // setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  const fileUploadHandler = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }
    setSelectedFile(e.target.files[0]);
  };

  return (
    <>
      <Modal
        open={showModal}
        onClose={closeModalHandler}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="members__modal">
          <div className="eventForm__close__icon">
            <span>Committe members</span>
            <Close style={{ cursor: "pointer" }} onClick={closeModalHandler} />
          </div>
          <input
            type="file"
            accept="image/*"
            hidden
            id="member__file"
            onChange={fileUploadHandler}
          />
          <div>
            <label
              htmlFor="member__file"
              style={{
                color: "white",
                padding: "5px",
                backgroundColor: "#3f51b5",
                borderRadius: "3px",
                fontSize: "14px",
                margin: "auto",
                cursor: "pointer",
              }}
            >
              Choose*
            </label>
          </div>
          <div className="members__modal__imageContainer">
            <img className="members__image" src={preview} alt="" />
          </div>
          <p>First Name:*</p>
          <input
            required
            placeholder="First Name"
            value={firstName}
            onChange={(e) => {
              let temp = e.target.value.trim();
              temp = temp.charAt(0).toUpperCase() + temp.substring(1);
              setFirstName(temp);
            }}
          />
          <p>Middle Name:</p>
          <input
            placeholder="Middle Name"
            value={middleName}
            onChange={(e) => {
              let temp = e.target.value.trim();
              temp = temp.charAt(0).toUpperCase() + temp.substring(1);
              setMiddleName(temp);
            }}
          />
          <p>Last Name:</p>
          <input
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => {
              let temp = e.target.value.trim();
              temp = temp.charAt(0).toUpperCase() + temp.substring(1);
              setLastName(temp);
            }}
          />

          <p>Priority:</p>
          <input
            placeholder="Priority"
            type="number"
            value={priority}
            onChange={(e) => setPriority(e.target.value)}
          />
          <label>
            <p>Designation*</p>

            <select
              onChange={(e) => setDesignation(e.target.value)}
              // defaultValue="Default"
              value={designation}
            >
              <option value="Default" disabled>
                Select
              </option>
              <option value="President">President/अध्यक्ष</option>
              <option value="First Vice President">
                First Vice President/पहले उपाध्यक्ष
              </option>
              <option value="Vice President">Vice President/उपाध्यक्ष</option>
              <option value="General Secretary">
                General Secretary/महामंत्री
              </option>
              <option value="Joint Secretary and Treasurer">
                Joint Secretary and Treasurer/सह मंत्री एवं कोषाध्यक्ष
              </option>
              <option value="Chairman Monitoring Committe">
                Chairman Monitoring Committe
              </option>
              <option value="Secretary">Secretary/सचिव</option>
              <option value="Joint Secretary">Joint Secretary/सह सचिव</option>
            </select>
          </label>

          <label>
            <p>Department*</p>
            <select
              onChange={(e) => setDepartment(e.target.value)}
              // defaultValue="Default"
              value={department}
            >
              <option value="Default" disabled>
                Select
              </option>
              <option value="Jain Samaj">Jain Samaj</option>
              <option value="Treasurer">Treasurer/कोषाध्यक्ष</option>
              <option value="Advisor, Jain Bhawan Committe">
                Advisor, Jain Bhawan Committe
              </option>
              <option value="Advisor, Mahavir Bhawan Committe">
                Advisor, Mahavir Bhawan Committe
              </option>
              <option value="Advisor, Jain School Committe">
                Advisor, Jain School Committe
              </option>
              <option value="Advisor, Construction Committe">
                Advisor, Construction Committe
              </option>
              <option value="Advisor, Jain College Committe">
                Advisor, Jain College Committe
              </option>
              <option value="Advisor, Saint related matters Committe">
                Advisor, Saint realted matters Committe
              </option>
              <option value="Information & Publicity">
                Information & Publicity
              </option>
              <option value="Finance Secretary">Finance Secretary</option>
              <option value="Jain College">Jain College</option>
              <option value="Jain School">Jain School</option>
              <option value="Jain Bhawan">Jain Bhawan</option>
              <option value="Jain Hospital">Jain Hospital</option>
              <option value="Mahavir Bhawan">Mahavir Bhawan</option>
              <option value="Saints">Saints</option>
              <option value="Puchara Committe">Puchara Committe</option>
              <option value="Mahavir Sthal">Mahavir Sthal</option>
              <option value="Cultural department and Pathshala">
                Cultural department and Pathshala/सांस्कृतिक विभाग एवं पाठशाला
              </option>
              <option value="Public Relations Officer">
                Public Relations Officer/जन संपर्क अधिकारी
              </option>
              <option value="Executive member">
                Executive member/कार्यकारिणी सदस्य
              </option>
            </select>
          </label>

          {!(
            firstName &&
            designation !== "Default" &&
            department !== "Default" &&
            preview
          ) && (
            <i style={{ textAlign: "center", color: "red" }}>
              *Fill required fields to submit
            </i>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={submitHandler}
            disabled={
              modalLoading ||
              !(
                firstName &&
                designation !== "Default" &&
                department !== "Default"
              )
            }
          >
            {modalLoading ? (
              <CircularProgress style={{ color: "#3f51b5" }} />
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default MembersForm;
